// @flow
import dotProp from 'dot-prop-immutable'
import { buildReducer } from '../lib/buildReducer'
import * as ActionTypes from './actionTypes'
import type {
  HashState,
  SetAction,
  ToggleAction,
  IncrementByAction,
  MultipleSetAction,
  DelKeysAction,
  DelAllKeysAction
} from './types'
export * from './actions'
export * from './selectors'
export * from './types'

const reducer = buildReducer(
  {},
  {
    [ActionTypes.HSET]: (state: HashState, action: SetAction) => {
      const { value, path } = action.payload
      return dotProp.set(state, path, value)
    },
    [ActionTypes.HSETNX]: (state: HashState, action: SetAction) => {
      const { value, path } = action.payload
      if (dotProp.get(state, path)) {
        return state
      } else {
        return dotProp.set(state, path, value)
      }
    },
    [ActionTypes.HMSET]: (state: HashState, action: MultipleSetAction) => {
      const { value, path } = action.payload
      return dotProp.merge(state, path, value)
    },
    [ActionTypes.HINCRBY]: (state: HashState, action: IncrementByAction) => {
      const { value, path } = action.payload
      if (dotProp.get(state, path)) {
        return dotProp.set(state, path, v => {
          return (Number(v) || 0) + value
        })
      } else {
        return dotProp.set(state, path, value)
      }
    },
    [ActionTypes.HTOGGLE]: (state: HashState, action: ToggleAction) => {
      const { path } = action.payload
      const currentValue = Boolean(dotProp.get(state, path))
      return dotProp.set(state, path, !currentValue)
    },
    [ActionTypes.HDEL]: (state: HashState, action: DelKeysAction) => {
      const { path, keys } = action.payload
      return keys.reduce((state, key) => {
        return dotProp.delete(state, [path, key].join('.'))
      }, state)
    },
    [ActionTypes.HDELALL]: (state: HashState, action: DelAllKeysAction) => {
      const { path } = action.payload
      return dotProp.delete(state, path)
    }
  }
)

export default reducer



// WEBPACK FOOTER //
// ./src/modules/hash/index.js